<script setup lang="ts">
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { TextSecondary } from '@shared/ui/typography'
import { BtnRadio } from '@shared/ui/button'

defineOptions({
  name: 'RadioItem',
})

const props = withDefaults(defineProps<RadioItemProps>(), {
  checked: false,
  disabled: false,
  label: '',
  mode: 'normal',
})

const emit = defineEmits<{
  click: []
}>()

interface RadioItemProps {
  checked?: boolean
  disabled?: boolean
  label?: string
  mode?: InputMode
}

const handleClick = (): void => {
  if (!props.disabled) {
    emit('click')
  }
}
</script>

<template>
  <div
    class="radio-item"
    @click="handleClick"
  >
    <BtnRadio
      :checked="checked"
      :mode="mode"
    />
    <TextSecondary>
      {{ label }}
    </TextSecondary>
  </div>
</template>

<style scoped lang="scss" src="./RadioItem.scss" />